import { styled, CommonStyles, useClickOutside, SubTitle, Body, Shape } from '@teko/ds-foundation';
import { CheckOutlined, RightOutlined } from '@teko/ds-icon';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { t } from '../../i18n.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const optionHeight = 2.5;
const Item = styled.div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return `
    height: ${optionHeight}rem;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    align-items: center;
    background: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
    padding-left: ${(_b = props.theme) == null ? void 0 : _b.spacing.s16};
    padding-right: ${(_c = props.theme) == null ? void 0 : _c.spacing.s16};
    border-radius: ${(_d = props.theme) == null ? void 0 : _d.borderRadius.s};
    cursor: pointer;
    &:hover {
      background: ${(_e = props.theme) == null ? void 0 : _e.colors.background};
    }
    ${props.hasDivider ? ` &:after {
         position: absolute;
         box-sizing: border-box;
         content: ' ';
         pointer-events: none;
         right: ${(_f = props.theme) == null ? void 0 : _f.spacing.s16};
         bottom: 0;
         left: ${(_g = props.theme) == null ? void 0 : _g.spacing.s16};
         border-bottom: ${(_h = props.theme) == null ? void 0 : _h.borderWeight.m} solid ${(_i = props.theme) == null ? void 0 : _i.colors.divider};
         -webkit-transform: scaleY(0.5);
         transform: scaleY(0.5);
       }` : ``}
`;
});
const LeftContent = styled.div`
  flex: 1;
  text-align: left;
`;
const RightContent = styled.div`
  width: 1.5rem;
  text-align: right;
`;
const ItemsWrapper = styled.div(({ theme, maxPerView }) => `
    background: ${theme == null ? void 0 : theme.colors.white};
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
    border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    ::-webkit-scrollbar {
      display: none;
    }
    position: absolute;
    top: 2.75rem;
    width: 100%;
    padding: 0.25rem;
    z-index: 1000;
    ${maxPerView ? `height: ${maxPerView * optionHeight + 0.5}rem;` : ""}
`);
const SelectWrapper = styled.div`
  position: relative;
`;
const Wrapper = styled.div`
  ${CommonStyles}
`;
const Field = styled.div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  return `
  padding-left: ${(_a = props.theme) == null ? void 0 : _a.spacing.s12};
  padding-right: ${(_b = props.theme) == null ? void 0 : _b.spacing.s12};
  background: ${(_c = props.theme) == null ? void 0 : _c.colors.white};
  height: 2.5rem;
   border-radius: ${(_f = (_d = props.theme) == null ? void 0 : _d.borderRadius[props.borderRadius]) != null ? _f : (_e = props.theme) == null ? void 0 : _e.spacing.s4};
  display: flex;
  align-items: center;
  border: ${(_g = props.theme) == null ? void 0 : _g.borderWeight.m} solid ${(_h = props.theme) == null ? void 0 : _h.colors.divider};
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  ${props.disabled ? `
    cursor: not-allowed;
    background: ${(_i = props.theme) == null ? void 0 : _i.colors.background};
  ` : ""}
  ${!props.active ? `&:hover {
    border: ${(_j = props.theme) == null ? void 0 : _j.borderWeight.m} solid ${(_k = props.theme) == null ? void 0 : _k.colors.placeholder};` : ""}
  }
  ${props.active ? `
    border: ${(_l = props.theme) == null ? void 0 : _l.borderWeight.m} solid ${props.activeColor || ((_m = props.theme) == null ? void 0 : _m.colors.link500)};
  ` : ""}
`;
});
const RightOutlinedWrapper = styled.div(({ transform }) => `
    position: relative;
    right: -0.25rem;
    transition: 0.2s;
    ${transform ? `
    transform: rotate(90deg);
    ` : ""}
`);
const findOptionByValue = (options, value) => {
  return options.find((option) => option.value === value);
};
const Select = (_a) => {
  var _b = _a, {
    value,
    title,
    options = [],
    maxPerView,
    disabled = false,
    hasDivider = false,
    activeColor,
    selectValue,
    className,
    borderRadius = "s",
    dropdownIcon = /* @__PURE__ */ React.createElement(RightOutlined, {
      color: "placeholder",
      size: 24
    })
  } = _b, rest = __objRest(_b, [
    "value",
    "title",
    "options",
    "maxPerView",
    "disabled",
    "hasDivider",
    "activeColor",
    "selectValue",
    "className",
    "borderRadius",
    "dropdownIcon"
  ]);
  const optionRef = useRef(null);
  const selectRef = useRef(null);
  const [show, setShow] = useState(false);
  const [activeOption, setActiveOption] = useState();
  useEffect(() => {
    setActiveOption(findOptionByValue(options, value));
  }, [value]);
  const onClickItem = (option) => {
    selectValue(option.value);
    setShow(false);
  };
  const toggle = useCallback(() => {
    setShow(false);
  }, []);
  useClickOutside([selectRef, optionRef], toggle);
  if (!options.length)
    return null;
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    className
  }, rest), title && /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4,
    line: 1,
    marginBottom: "s4"
  }, title), /* @__PURE__ */ React.createElement(SelectWrapper, {
    ref: selectRef
  }, /* @__PURE__ */ React.createElement(Field, {
    disabled,
    activeColor,
    borderRadius,
    onClick: (e) => {
      e.stopPropagation();
      if (!disabled)
        setShow(!show);
    },
    active: show
  }, /* @__PURE__ */ React.createElement(LeftContent, null, /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    line: 1
  }, (activeOption == null ? void 0 : activeOption.text) || t("Ch\u1ECDn"))), /* @__PURE__ */ React.createElement(RightContent, null, /* @__PURE__ */ React.createElement(RightOutlinedWrapper, {
    transform: show
  }, dropdownIcon))), show && /* @__PURE__ */ React.createElement(ItemsWrapper, {
    ref: optionRef,
    maxPerView: (maxPerView != null ? maxPerView : Number.MAX_SAFE_INTEGER < options.length) ? maxPerView : void 0
  }, options.map((option, index) => {
    var _a2, _b2, _c, _d;
    return /* @__PURE__ */ React.createElement(Item, {
      key: index,
      onClick: () => onClickItem(option),
      hasDivider: index === options.length - 1 ? false : hasDivider
    }, option.icon && /* @__PURE__ */ React.createElement(Shape, {
      marginRight: "s12"
    }, React.cloneElement(option.icon, {
      size: !((_b2 = (_a2 = option.icon) == null ? void 0 : _a2.props) == null ? void 0 : _b2.size) ? 24 : (_d = (_c = option.icon) == null ? void 0 : _c.props) == null ? void 0 : _d.size
    })), /* @__PURE__ */ React.createElement(LeftContent, null, /* @__PURE__ */ React.createElement(Body, {
      level: 1,
      line: 1
    }, option.text)), value === option.value && /* @__PURE__ */ React.createElement(RightContent, null, /* @__PURE__ */ React.createElement(CheckOutlined, {
      size: 24,
      color: activeColor || "primary500"
    })));
  }))));
};

export { Select };
